module.exports = __webpack_public_path__ + "img/29@2x.556858a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/29@2x.png
// module id = qX50
// module chunks = 0